module.exports = {
  'contact': 'Contact',
  'about_us': 'Legal',
  'privacy': 'Privacy',
  'work_title': 'Work',
  'work_description': 'We work as a team with our customers and build websites that inspire.',
  'services_title': 'Services',
  'services_description': 'We can do anything web related. And by everything we really mean everything.',
  'about_title': 'About us',
  'about_description': 'We are a full-service web agency based in Karlsruhe.',
  'project_ama_architekten_description': 'Strategy & conception, UX / UI design, responsive website',
  'project_yourproject_description': 'Strategy & consulting, branding, UX & UI design, responsive website',
  'project_steele_meals_description': 'Strategy & consulting, branding, UX & UI design, online shop',
  'project_baubranche_jobs_description': 'Strategy & consulting, branding, UX & UI design, responsive website',
  'project_my_source_nutrition_description': 'Strategy & consulting, branding, UX & UI design, online shop',
  'project_hellmann_description': 'Strategy & consulting, UX & UI design, web application',
  'to_the_page': 'Go to website',
  'project_kickass_description': 'Strategy & consulting, branding, UX & UI design, online shop',
  'project_philipp_seipp_description': 'Strategy & consulting, branding, UX & UI design, responsive website',
  'contact_description': 'Are you ready for your next web project with us?',
  'services': 'Services',
  'work': 'Work',
  'about': 'About Us',
  'service1_title': 'Strategy & Consulting',
  'service1_description': 'Before we start the actual implementation, we work with you to develop an action plan for your user and brand experiences.',
  'service2_title': 'UX & UI Design',
  'service2_description': 'As UX / UI designers, we create products and services that are characterized by excellent use and trigger a wow.',
  'service3_title': 'Websites & Webapps',
  'service3_description': 'Whether front-end or back-end, Angular or React, website or web app - we can do full stacks and only use the most modern technologies.',
  'service4_title': 'E-Commerce & Shops',
  'service4_description': 'We build online shops and develop stable processes. Magento, Shopify, WooCommerce or PayPal – we are familiar with these.',
  'service_large': 'We love the web, and we love unique websites even more. Whether strategy, design, or development, we have everything that is needed for this.',
  'learn_more': 'Learn more',
  'all_rights_reserved': 'All rights reserved.',
  'headline': 'As a full-service web agency, we develop ',
  'headline1': 'the user experiences of tomorrow<span class="black">.</span>',
  'headline2': 'websites that trigger a wow<span class="black">.</span>',
  'headline3': 'apps that are easy to use<span class="black">.</span>',
  'headline4': 'online shops that are fun<span class="black">.</span>',
  'ecommerce': 'E-Commerce',
  'uxdesign': 'UX/UI Design',
  'websites': 'Websites',
  'your_offer': 'Your offer',
  'show_more': 'Show more',
  'show_less': 'Show less',
  'create_contact': 'Make contact',
  'f_desc': 'We are a full-service agency based in Karlsruhe and have specialized in the development of unique user experiences.',
  'agency': 'Agency',
  'links': 'Links',
  'legal': 'Legal',
  'social': 'Social',
  'ux_ui_design': 'UX/UI Design'
};
